import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import './App.css';
import Login from "./screens/login/index"
import Home from "./screens/userProvider/home"
import HomeAdmin from './screens/userAdmin/home';
import CreatePassword from './screens/createPassword';
import { AuthProvider } from './context/auth';
import { NotificationsProvider } from './context/notifications';
import ProtectedRoute from './context/protectedRoute/index';
import Error404 from './screens/errorPages/error404';
import Error403 from './screens/errorPages/error403';

////////////////////PROVIDER//////////////////////
import OCProvider from "./screens/userProvider/followUp/OC"
import Buyers from './screens/userProvider/followUp/buyers';
import Benefits from './screens/userProvider/providers/benefits';
import Evaluation from './screens/userProvider/providers/evaluation';
import AppointmentProvider from './screens/userProvider/resoucers/appointment';
import Manuals from './screens/userProvider/manuals';
import Requirements from './screens/userProvider/documentation/seasonStartRequirements';
import Ranking from './screens/userProvider/providers/ranking';

import NewsDetailProvider from './screens/userProvider/knowUs/newsDetail';
import KnowUsProvider from './screens/userProvider/knowUs';

import SurveyProvider from './screens/userProvider/documentation/survey';
import AnswerSurvey from './screens/userProvider/documentation/survey/answerSurvey';
import ATCProvider from './screens/userProvider/followUp/ATC';
import BillingProvider from './screens/userProvider/followUp/billing';

///////////////////ADMIN///////////////////////////

import BenefitsAdmin from './screens/userAdmin/provider/benefits';

//registro usuario
import UserRegister from './screens/userAdmin/register/userRegister';

import PreviewBuyerUser from './screens/userAdmin/register/excelPreview/buyerUser';
import PreviewProviderUser from './screens/userAdmin/register/excelPreview/providerUser';
import PreviewAdminUser from './screens/userAdmin/register/excelPreview/adminUser';
import PreviewGuestUser from './screens/userAdmin/register/excelPreview/guestUser';

import ListBuyerUser from './screens/userAdmin/register/list/buyerUser';
import ListAdminUser from './screens/userAdmin/register/list/adminUser';
import ListProviderUser from './screens/userAdmin/register/list/providerUser';
import ListGuestUser from './screens/userAdmin/register/list/guestUser';

import Configuration from './screens/userAdmin/configuration';
import KnowUs from './screens/userAdmin/knowUs';

import EvaluationAdmin from './screens/userAdmin/provider/evaluation';
import CriteriaAdmin from './screens/userAdmin/provider/criteria';

import BuyersAdmin from './screens/userAdmin/followUp/buyers';

import OCAdmin from './screens/userAdmin/followUp/oc';
import HistoricOCAdmin from './screens/userAdmin/followUp/oc/historicOC';

import AnnouncementsPublish from './screens/userAdmin/announcements/publish';
import AnnouncementsHistorical from './screens/userAdmin/announcements/historical';
import AnnouncementsEdit from './screens/userAdmin/announcements/edit';

import ManualsAdmin from './screens/userAdmin/manuals';

import CreateNewsDetail from './screens/userAdmin/knowUs/createNewsDetail/index';
import UpdateNewsDetail from './screens/userAdmin/knowUs/updateNewsDetail';

import { MicrosoftAuth } from './screens/userAdmin/microsoft';

import SeasonStartRequirements from './screens/userAdmin/seasonStartRequirements';
import Documents from './screens/userAdmin/documentation/documents';
import Seasons from './screens/userAdmin/documentation/seasons';
import SurveyAdmin from './screens/userAdmin/documentation/survey';
import SurveyHistory from './screens/userAdmin/documentation/survey/surveyHistory';
import DetailsCompletedSurveys from './screens/userAdmin/documentation/survey/detailsCompletedSurveys';
import CreateSurvey from './screens/userAdmin/documentation/survey/createSurvey';
import EditSurvey from './screens/userAdmin/documentation/survey/editSurvey';

import ATCAdmin from './screens/userAdmin/followUp/atc';
import BillingAdmin from './screens/userAdmin/followUp/billing';
import AppointmentAdmin from './screens/userAdmin/resources/appointment';
import ScheduleAdmin from './screens/userAdmin/resources/schedule';

import { useAuth } from './context/auth';
import { hasPermission } from './context/permissionsMapping';
import HistoricNotification from './screens/notifications';
import { WebSocketProvider } from './context/webSocket';

const ProtectedNotificationRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return null; 
  }
  
  if (user?.roleId === 2) {
    return <HistoricNotification />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;
};

const HomeComponent = () => {
  const { permissions } = useAuth();
  
  if (hasPermission(permissions, 16)) {
    return <HomeAdmin />;
  }
  if (hasPermission(permissions, 23)) {
    return <Home />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;
};

const CompradoresComponent = () => {
  const { permissions } = useAuth();
  
  if (hasPermission(permissions, 5)) { 
    return <BuyersAdmin />;
  }
  if (hasPermission(permissions, 26)) { 
    return <Buyers />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;

};

const ManualsComponent = () => {
  const { permissions } = useAuth();
  
  if (hasPermission(permissions, 10)) { // Permiso de admin para manuales
    return <ManualsAdmin />;
  }
  if (hasPermission(permissions, 30)) { // Permiso de proveedor para manuales
    return <Manuals />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;
};

const KnowUsComponent = () => {
  const { permissions } = useAuth();
  
  if (hasPermission(permissions, 32)) { // Permiso de admin para conocenos
    return <KnowUs />;
  }
  if (hasPermission(permissions, 33)) { // Permiso de proveedor para conocenos
    return <KnowUsProvider />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;
};

const RequirementsComponent = () => {
  const { permissions } = useAuth();
  
  if (hasPermission(permissions, 34)) { // Permiso de admin para req temp
    return <SeasonStartRequirements />;
  }
  if (hasPermission(permissions, 35)) { // Permiso de proveedor para req temp
    return <Requirements />;
  }
  
  return <Navigate to="/acceso-restringido" replace />;
};

function App() {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <WebSocketProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
  
              {/**LOGIN MICROSOFT */}
              <Route path="/auth/microsoft" element={<MicrosoftAuth />} />
              <Route path="/first-login" element={<CreatePassword />} />
  
  
              <Route element={<ProtectedRoute />}>
                <Route path="/inicio" element={<HomeComponent />} />
              </Route>
  
              {/* Ruta unificada para compradores */}
              <Route element={<ProtectedRoute />}>
                <Route path="/compradores" element={<CompradoresComponent />} />
              </Route>
  
              {/* Ruta unificada para manuales */}
              <Route element={<ProtectedRoute />}>
                <Route path="/manuales-de-informacion" element={<ManualsComponent />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={1} />}>
                <Route path="/oc" element={<OCAdmin />} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={24} />}>
                <Route path="/mis-oc" element={<OCProvider />} />
                
                <Route element={<ProtectedRoute hasEvaluationRequired={true} />}>
                  <Route path="/mis-beneficios" element={<Benefits />} />
                  <Route path="/mi-evaluacion/:supplierId" element={<Evaluation />} />
                  <Route path="/ranking" element={<Ranking/>} />
                </Route>
                
                {/*<Route path="/gestion-de-citas" element={<AppointmentProvider />} />
                
              */}
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={25} />}>
                <Route path="/oc-historico" element={<HistoricOCAdmin />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={8} />}>
                <Route path="/beneficios" element={<BenefitsAdmin />} />
              </Route>
              <Route element={<ProtectedRoute hasEvaluationRequired={true} requiredPermission={29} />}>
                <Route path="/mis-beneficios" element={<Benefits />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={7} />}>
                <Route path="/evaluacion" element={<EvaluationAdmin />} />
              </Route>
              <Route element={<ProtectedRoute requiredPermission={28} hasEvaluationRequired={true}  />}>
                <Route path="/mi-evaluacion/:supplierId" element={<Evaluation />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={9} hasEvaluationRequired={true}/>}>
                <Route path="/ranking" element={<Ranking />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={27} />}>
                <Route path="/criterios-de-evaluacion" element={<CriteriaAdmin />} />
              </Route>
  
              {/**ANUNCIOS */}
              <Route element={<ProtectedRoute requiredPermission={31} />}>
                <Route path="/publicar-anuncio" element={<AnnouncementsPublish />} />
                <Route path="/historial-anuncios" element={<AnnouncementsHistorical />} />
                <Route path="/editar-anuncio/:id" element= {<AnnouncementsEdit />} />
              </Route>
  
              {/**USUARIOS */}
              <Route element={<ProtectedRoute requiredPermission={15} />}>
                <Route path="/registro-usuario" element={<UserRegister />} />
                <Route path="/prev-lista-comprador" element={<PreviewBuyerUser />} />
                <Route path="/prev-lista-proveedor" element={<PreviewProviderUser />} />
                <Route path="/prev-lista-administrador" element={<PreviewAdminUser />} />
                <Route path="/prev-lista-invitado" element={<PreviewGuestUser />} />
                <Route path="/lista-comprador" element={<ListBuyerUser />} />
                <Route path="/lista-administrador" element={<ListAdminUser />} />
                <Route path="/lista-proveedor" element={<ListProviderUser />} />
                <Route path="/lista-invitado" element={<ListGuestUser />} />
              </Route>
  
              {/* Configuración */}
              <Route element={<ProtectedRoute requiredPermission={20} />}>
                <Route path="/administrar-accesos" element={<Configuration />} />
              </Route>
  
  
              {/**conocenos */}
              <Route element={<ProtectedRoute />}>
                <Route path="/conocenos" element={<KnowUsComponent />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={32} />}>
                <Route path="/crear-detalle-noticia" element={<CreateNewsDetail />} />
                <Route path="/actualizar-noticia/:id" element={<UpdateNewsDetail />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={33} />}>
                <Route path="/detalle-noticia/:id" element={<NewsDetailProvider />} />
              </Route>
  
              {/** DOCUMENTACION  */}
              <Route element={<ProtectedRoute />}>
                <Route path="/requisitos-de-inicio-de-temporada" element={<RequirementsComponent />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={36} />}>
                <Route path="/documentos" element={<Documents />} />
              </Route>
  
              <Route element={<ProtectedRoute requiredPermission={37} />}>
                <Route path="/temporadas" element={<Seasons />} />
              </Route>
  
              
              {/**encuestas admin */}
              <Route element={<ProtectedRoute requiredPermission={38} />}>
                <Route path="encuestas" element={<SurveyAdmin />} />
                <Route path="crear-encuesta" element={<CreateSurvey />} />
                <Route path="actualizar-encuesta/:surveyId" element={<EditSurvey />} />
  
              </Route>
              
              <Route element={<ProtectedRoute requiredPermission={39} />}>
                <Route path="historico-de-encuestas" element={<SurveyHistory />} />
                <Route path="respuestas-encuesta/:surveyId" element={<DetailsCompletedSurveys />} />
              </Route>
  
                {/**Encuestas proveedor */}
              <Route element={<ProtectedRoute requiredPermission={40} />}>
                <Route path="mis-encuestas" element={<SurveyProvider />} />
                <Route path="completar-encuesta/:surveyId" element={<AnswerSurvey />} />
              </Route>
  
              {/**ATC Proveedor */}
  
              <Route element={<ProtectedRoute requiredPermission={42} />}>
                <Route path="mis-atc" element={<ATCProvider />} />
              </Route>
  
              {/**ATC Admin */}
              <Route element={<ProtectedRoute requiredPermission={41} />}>
                <Route path="atc" element={<ATCAdmin />} />
              </Route>
  
  
              {/**Facturacion Admin */}
              <Route element={<ProtectedRoute requiredPermission={43} />}>
                <Route path="facturacion" element={<BillingAdmin />} />
              </Route>
  
              {/**Facturacion Proveedor */}
              <Route element={<ProtectedRoute requiredPermission={44} />}>
                <Route path="mi-facturacion" element={<BillingProvider />} />
              </Route>
  
  
  
              {/**Gestion citas Admin */}
              <Route element={<ProtectedRoute requiredPermission={45} />}>
                <Route path="gestion-de-citas" element={<AppointmentAdmin />} />
              </Route>
  
              {/**Agendar cita Proveedor */}
              <Route element={<ProtectedRoute requiredPermission={46} />}>
                <Route path="agendar-cita" element={<AppointmentProvider />} />
              </Route>
  
              {/**Gestion horarios Admin*/}
              <Route element={<ProtectedRoute requiredPermission={47} />}>
                <Route path="gestion-de-horarios" element={<ScheduleAdmin />} />
              </Route>
  
              <Route path="historico-de-notificaciones" element={<ProtectedNotificationRoute />} />
  
              <Route path="*" element={<Error404 />} />
              <Route path="/acceso-restringido" element={<Error403 />} />
  
              
  
            </Routes>
          </Router>
        </WebSocketProvider>
      </NotificationsProvider>
    </AuthProvider>
  );
}

export default App;
